import { createFileRoute } from '@tanstack/react-router'
import { PointCloudHomeContent } from 'pages/pointClouds/components/home/PointCloudHomeContent'
import { pointCloudIndexSearchParams } from 'routes/point-cloud/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return <PointCloudHomeContent orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/point-cloud/')({
  component: RouteComponent,
  validateSearch: pointCloudIndexSearchParams,
  staticData: {
    title: 'Point Clouds',
  },
})
